
export const firebaseConfig = {
    apiKey: "AIzaSyAY2x_v9KHISlNX-Ix_13PHRwNRWwiKTXg",
    authDomain: "liff-shop.firebaseapp.com",
    databaseURL: "https://liff-shop.firebaseio.com",
    projectId: "liff-shop",
    storageBucket: "liff-shop.appspot.com",
    messagingSenderId: "60797073780",
    appId: "1:60797073780:web:28c0f6fde9a14ed2"
};